module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 console.log(content) 
__p+='\n';
 var productsData = content.productdata 
__p+='\n';
 for (var i = 0; i < content.maxCompareNum; i++) { 
__p+='\n    ';
 if ( typeof productsData[i] === 'undefined' ) { 
__p+='\n        <div class="item empty" >\n            <div class="product-image">\n            </div>\n        </div>\n    ';
 } else { 
__p+='\n        <div class="item" data-id="'+
((__t=( productsData[i].id ))==null?'':__t)+
'">\n            <div class="product-image">\n                ';
 if (productsData[i].image) { 
__p+='\n                <img src="'+
((__t=( productsData[i].image ))==null?'':__t)+
'" alt="'+
((__t=( productsData[i].alt ))==null?'':__t)+
'">\n                ';
 } 
__p+='\n                <button type="button" name="remove" class="remove">X</button>\n            </div>\n            <div class="product-info">\n                <p class="product-name">'+
((__t=( productsData[i].name ))==null?'':__t)+
'</p>\n                <a href="'+
((__t=( productsData[i].url ))==null?'':__t)+
'" target="_blank" title="'+
((__t=( productsData[i].name ))==null?'':__t)+
'">View Details</a>\n            </div>\n        </div>\n    ';
 } 
__p+='\n';
 } 
__p+='';
}
return __p;
};
